<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content" style="padding-bottom:0;">
        <div v-if="$store.getters.enableFrontEndPlugin && isSalesForSzfs">
          <micro-app
            name="child-sale-role-hide-costplan"
            :url="$store.getters.frontEndPluginUrl+'/saleRoleHideItem'"
            router-mode="pure"
            destroy
            @datachange="saleRoleHideDataChange"
          />
        </div>
        <search-item
          ref="searchItem"
          :show-more-scheme="true"
          :show-condition="false"
          :expand-adv="true"
          :custom-sim-query-placeholder="$t('Information.QuickSearch')+$t('CargoMsg.Cargo_ProductName')"
          config-module="102101"
          :auto-init="searchItemAutoInit||true"
          :custom-search-items="customSearchItems"
          @query="queryBtnClickHandler"
        >
          <div slot="operations" class="triggers">
            <!--新增-->
            <el-button no="Add" type="primary" @click="popCostPlanAddFormDialog">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <!--复制新增-->
            <el-button no="CopyAndAddPoItems" type="primary" @click="copyPopCostPlanAddFormDialog">{{ $t('CargoMsg.Cargo_CopyAndAddPoItems') }}</el-button>
            <!--编辑-->
            <el-button v-if="editByRole" no="Edit" :disabled="!(selectedRow&&selectedRow.approvedState===0)" type="primary" @click="editFormDialog">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <!--删除-->
            <el-button v-if="deleteByRole" no="Delete" :disabled="!(selectedRow&&selectedRow.approvedState===0)" type="danger" @click="toDelete">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            <!--提交-->
            <el-button v-if="needApprove" no="BatchCommit" type="primary" @click="submitSchemeHandler">{{ $t('SeaExport.BatchCommit') }}</el-button>
            <!--审核/取消审核-->
            <el-button v-if="needApprove&&canAudit" no="BatchAudit" type="primary" @click="batchAuditHandler"> {{ $t('CargoMsg.Cargo_BatchAudit') }}</el-button>
            <el-button v-if="needApprove&&canAudit" no="BatchCancelAudit" type="primary" @click="batchCancelAuditHandler"> {{ $t('CargoMsg.Cargo_BatchCancelAudit') }}</el-button>
            <!--拒绝-->
            <el-button v-if="needApprove&&canReject" no="BulkRejection" type="primary" @click="rejectSchemeHandler">{{ $t('Information.BulkRejection') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="100701"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            config-module="100701"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchCostPlanList"
          />
        </div>
      </div>
      <!-- 费用方案维护 -->
      <charge-scheme-dialog
        :v-if="chargeSchemeDialog.visible"
        :visible.sync="chargeSchemeDialog.visible"
        :context="this"
        :charge-scheme="chargeSchemeDialog.chargeScheme"
        :status.sync="chargeSchemeDialog.status"
        :locked="chargeSchemeDialog.locked"
        :sale-role-hide="saleRoleHide"
      />
      <reject-dialog
        :v-if="rejectDialog.visible"
        :visible.sync="rejectDialog.visible"
        :reject-call-back="rejectDialog.func"
      />
      <business-copy-window
        v-show="copyDialog.visible"
        ref="costPlanCopyWindow"
        source="COST_PLAN"
        :visible.sync="copyDialog.visible"
        @confirmCallBack="copyDialog.confirmCallBackHandler"
      />
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import rejectDialog from '@/views/cargo/v0/Information/components/costPlan/rejectDialog'
import URL from '@/api/urlTranslator'
import {
  getCostPlanList,
  batchDelCostPlan,
  batchUpdateStateFunc,
  queryChargeScheme
} from '@/api/costPlan'
import deSchemeDetail from './components/costPlan/dgSchemeDetail'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import chargeSchemeDialog from '@/views/cargo/v0/Information/components/costPlan/chargeSchemeDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CommonState from '@/class/cargo/model/parameters/CommonState'
import { cacheName, cache } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import BusinessCopyWindow from '@/components/Cargo/Job/businessCopyWindow.vue'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import microApp from '@micro-zoe/micro-app'

export default {
  name: 'CostPlan',
  components: { BusinessCopyWindow, cargoAdvanceSelect, deSchemeDetail, chargeSchemeDialog, searchItem, rejectDialog },
  data() {
    return {
      gridApi: null,
      selectedRow: null,
      selectedDataList: [],
      needApprove: false,
      loading: false,
      searchItemAutoInit: false,
      selectTypeNames: TYPE_NAMES,
      allByRole: false, // 查看所有
      departmentByRole: false, // 查看同组
      copyDialog: {
        visible: false,
        confirmCallBackHandler: () => {
          this.doCopyCostPlan()
        }
      },
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onSortChanged: (event) => {
          if (event && event.api && event.api.rowRenderer) {
            const rowComps = event.api.rowRenderer.rowCompsByIndex
            if (!rowComps) return
            const currentSortJobs = []
            for (const key in rowComps) {
              if (!rowComps[key].rowNode || !rowComps[key].rowNode.data) continue
              currentSortJobs.push(rowComps[key].rowNode.data)
            }
            this.rowData = currentSortJobs
          }
        },
        onRowClicked: this.rowClickedHandler,
        onRowDoubleClicked: this.popCostPlanEditFormDialog,
        // 行勾选事件
        onRowSelected: this.onRowSelected
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '', width: 30, checkboxSelection: true,
          suppressSorting: true, suppressMenu: true, suppressSizeToFit: true, suppressResize: true,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          width: 150,
          cellRenderer: params => { return ColumnUtils.chargeSchemeJobBussStateLabelFunc(params.value) }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ProductName'),
          field: 'name',
          colId: 'name',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerStr',
          colId: 'customerStr',
          width: 200,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_Carrier'),
          field: 'carrierStr',
          colId: 'carrierStr',
          width: 200,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
          field: 'bookingAgentStr',
          colId: 'bookingAgentStr',
          width: 200,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_TypeOfGoods'),
          field: 'cargoType',
          colId: 'cargoType',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FLCLType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          width: 200,
          cellRenderer: (params) => {
            let msg = ''
            if (params.value) {
              const arr = params.value.split(',')
              const result = []
              let lob = params.data.lob || ''
              if (params.data.lob === 'FBA_SE') {
                lob = 'SE'
              }
              if (params.data.lob === 'FBA_AE') {
                lob = 'AE'
              }
              if (params.data.lob === 'FBA_RE') {
                lob = 'RE'
              }
              let cargoTypes = ChargeUtils.getCargoType(lob)
              if (cargoTypes) {
                cargoTypes = Array.from(cargoTypes)
                for (const val of arr) {
                  const value = cargoTypes.find(cargoType => String(cargoType.code) === String(val))
                  if (value) {
                    result.push(value.chineseName)
                  }
                }
              }
              msg = result.join(',')
            }
            return msg
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ShippingRouteArea'),
          field: 'region',
          colId: 'region',
          width: 100,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreatedBy'),
          field: 'inputBy',
          colId: 'inputBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_EntryDate'),
          field: 'inputDate',
          colId: 'inputDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
          field: 'effectiveDate',
          colId: 'effectiveDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
          field: 'expiryDate',
          colId: 'expiryDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuditStatus'),
          field: 'approvedState',
          colId: 'approvedState',
          width: 120,
          cellRenderer: (params) => {
            return this.approvedStateLabFun(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Auditor'),
          field: 'approvedBy',
          colId: 'approvedBy',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReviewTime'),
          field: 'dateApproved',
          colId: 'dateApproved',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('ChangeCharge.businessAuditReason'),
          field: 'rejectReason',
          colId: 'rejectReason',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_DescriptionOfPlan'),
          field: 'remark',
          colId: 'remark',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationAgent'),
          field: 'destinationAgentStr',
          colId: 'destinationAgentStr',
          hide: true,
          width: 200,
          tooltipValueGetter: (params) => params.value
        }],
      searchConditions: {
        lob: '',
        fba: '',
        name: '',
        bookingAgent: null,
        customer: null,
        carrier: null,
        hsCodeTxt: '',
        pageNum: 1,
        pageSize: 30,
        total: 0,
        branchId: null
      },
      lobArray: [],
      approvedState: [
        new CommonState('', '所有', 'ALL'),
        new CommonState('0', '未提交', 'Not Submitted'),
        new CommonState('1', '已提交', 'Submitted'),
        new CommonState('2', '已审核', 'Verified')
      ],
      chargeSchemeDialog: {
        visible: false,
        status: 'add', // add|edit|copy
        locked: false,
        chargeScheme: null
      },
      rejectDialog: {
        visible: false,
        func: null
      },
      saleRoleHideData: { // 子应用销售角色移除搜索条件和显示字段
        viewSource: 'CostPlan',
        hide: false
      },
      saleRoleHide: false
    }
  },
  computed: {
    url() {
      return URL
    },
    customSearchItems() {
      return this.customSearchItemsInit()
    },
    canAudit() {
      return this.$checkPermission(['button_FMChargeScheme_audit'])
    },
    canReject() {
      return this.$checkPermission(['button_FMChargeScheme_reject'])
    },
    editByRole() {
      return this.$checkPermission(['button_FMChargeScheme_editByRole'])
    },
    deleteByRole() {
      return this.$checkPermission(['button_FMChargeScheme_deleteByRole'])
    },
    pleaseSelectChangeSchema() {
      return this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.ChangeSchema')
    },
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    // 深圳丰收销售专用
    isSalesForSzfs() {
      return String(cache.config.get('ToExoSystem')) === 'SZFS' && !this.$store.getters.isAdmin &&
        (this.$checkPermission(['role_salesOfGoods']) || this.$checkPermission(['role_RemoteBooking_queryPrivateCustom']) ||
          this.$checkPermission(['role_platform_sales']) || this.$checkPermission(['role_branchSales']) || this.$checkPermission(['role_sales']))
    }
  },
  watch: {
    officeId: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          await this.fetchCostPlanList()
        }
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.lobArray.push(new CommonState('', '所有', 'ALL'))
    this.lobArray.push(...SystemConstants.CHARGE_SCHEME_LOBS)
    this.allByRole = this.$checkPermission(['role_FMChargeScheme_ViewOfficeChargeScheme'])
    this.departmentByRole = this.$checkPermission(['role_FMChargeScheme_departmentQuery'])
    // 初始化费用方案列表
    await this.fetchCostPlanList()
    this.needApprove = Number(cache.config.get('ChargeSchemeIsApproved')) === 1
  },
  methods: {
    queryBtnClickHandler(conditionsMap) {
      this.searchConditionsReset()
      // 快捷查询
      if (conditionsMap.simpleTriggerMode) {
        const value = conditionsMap.conditions
        conditionsMap.conditions = []
        conditionsMap.conditions.push(new AdvancedSearchOption('FIELD_TEXT', 'name', value, AdvancedSearchConsts.OPERATOR_LIKE.code).formatObj2Json())
      }
      for (const condition of conditionsMap.conditions) {
        if (condition.value === null || condition.value === undefined || condition.value === '') continue
        this.searchConditions[condition.fieldName] = condition.value
      }
      // 承运人处理
      if (this.searchConditions.carrierIdShip && (!this.searchConditions.lob || this.searchConditions.lob === 'SE' || this.searchConditions.lob === 'SI')) {
        this.searchConditions.carrier = this.searchConditions.carrierIdShip
      } else if (this.searchConditions.carrierIdAir && (!this.searchConditions.lob || this.searchConditions.lob === 'AE' || this.searchConditions.lob === 'AI')) {
        this.searchConditions.carrier = this.searchConditions.carrierIdAir
      } else if (this.searchConditions.carrierIdRailway && (!this.searchConditions.lob || this.searchConditions.lob === 'RE')) {
        this.searchConditions.carrier = this.searchConditions.carrierIdRailway
      }
      // FBA业务处理
      if (this.searchConditions.lob) {
        if (this.searchConditions.lob === 'FBA_SE') {
          this.searchConditions.lob = 'SE'
          this.searchConditions.fba = true
        } else if (this.searchConditions.lob === 'FBA_AE') {
          this.searchConditions.lob = 'AE'
          this.searchConditions.fba = true
        } else if (this.searchConditions.lob === 'FBA_RE') {
          this.searchConditions.lob = 'RE'
          this.searchConditions.fba = true
        } else {
          this.searchConditions.fba = false
        }
      }
      this.fetchCostPlanList()
    },
    // 获取费用方案列表
    async fetchCostPlanList() {
      const self = this
      const params = { ...this.searchConditions }
      params.branchId = this.$store.getters.currentOfficeId
      params.isAdmin = this.allByRole
      const loading = getLoading()
      await getCostPlanList(params).then(res => {
        for (const each of res.data.list) {
          if (each.fba) {
            if (each.lob === 'SE') {
              each.lob = 'FBA_SE'
            }
            if (each.lob === 'AE') {
              each.lob = 'FBA_AE'
            }
            if (each.lob === 'RE') {
              each.lob = 'FBA_RE'
            }
          }
        }
        self.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        this.selectedDataList = []
      }).catch(e => {
        loading.close()
      }).finally(e => {
        loading.close()
      })
    },
    // 新增费用方案弹窗
    popCostPlanAddFormDialog() {
      this.chargeSchemeDialog.status = 'add'
      this.chargeSchemeDialog.chargeScheme = null
      this.chargeSchemeDialog.locked = false
      this.chargeSchemeDialog.visible = true
    },
    // 双击费用方案弹窗
    popCostPlanEditFormDialog(e) {
      this.selectedRow = e.data
      this.loadDetail('edit')
    },
    // 编辑费用方案弹窗
    editFormDialog() {
      this.loadDetail('edit')
    },
    rowClickedHandler(params) {
      this.selectedRow = params.data
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedRow = null
      const node = event.data
      if (node.uuid) {
        this.selectedRow = node
      }
    },
    // 删除费用方案
    async toDelete() {
      const currentRow = this.selectedRow
      if (!currentRow) {
        this.$message.error(this.pleaseSelectChangeSchema)
        return
      }
      const self = this
      await this.$confirm(this.$t('Information.DoWantToDelete0', [currentRow.name]), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      })
      const loading = getLoading()
      await batchDelCostPlan([currentRow.uuid]).then(res => {
        self.fetchCostPlanList()
        this.$message.success(this.$t('common.tips.deleteSuccess'))
      })
      loading.close()
    },
    copyPopCostPlanAddFormDialog() {
      if (!this.selectedRow) {
        this.$message.warning(this.pleaseSelectChangeSchema)
        return
      }
      // CARGO-31454 费用方案进行复制新增时，增加复制条件
      const ifNotShowDialog = LocalStorageUtilsNew.getConfiguration('COPY_COST_PLAN')
      if (ifNotShowDialog !== true) {
        this.copyDialog.visible = true
      } else {
        this.doCopyCostPlan()
      }
    },
    doCopyCostPlan() {
      this.loadDetail('copy')
    },
    // 提交 按钮事件
    submitSchemeHandler() {
      const rows = this.selectedDataList
      if (!rows || rows.length === 0) {
        this.$message.error(this.$t('Information.PleaseSelectData'))
        return
      }
      const index = rows.findIndex(p => p.approvedState !== 0)
      if (index !== -1) {
        this.$message.error(this.$t('Information.OnlySchemesWithAuditUnreviewed'))
        return
      }
      const uuids = []
      for (const r of rows) {
        uuids.push(r.uuid)
      }
      batchUpdateStateFunc(uuids, { type: 1 }).then(res => {
        this.$message.success(this.$t('Message.CommitSuccessfully'))
        this.fetchCostPlanList()
      })
    },
    // 审核 按钮事件
    async batchAuditHandler() {
      const rows = this.selectedDataList
      if (!rows || rows.length === 0) {
        this.$message.error(this.$t('Information.PleaseSelectData'))
        return
      }
      const index = rows.findIndex(p => p.approvedState !== 1)
      if (index !== -1) {
        this.$message.error(this.$t('Information.OnlySchemesWithAuditSubmitted'))
        return
      }
      const uuids = []
      for (const r of rows) {
        uuids.push(r.uuid)
      }
      batchUpdateStateFunc(uuids, { type: 2 }).then(res => {
        this.$message.success(this.$t('Message.AuditSuccessfully'))
        this.fetchCostPlanList()
      })
    },
    async batchCancelAuditHandler() {
      const rows = this.selectedDataList
      if (!rows || rows.length === 0) {
        this.$message.error(this.$t('Information.PleaseSelectData'))
        return
      }
      const index = rows.findIndex(p => p.approvedState !== 2)
      if (index !== -1) {
        this.$message.error(this.$t('Information.OnlySchemesWithAuditReviewed'))
        return
      }
      const uuids = []
      for (const r of rows) {
        uuids.push(r.uuid)
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToCancelVerification'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning', closeOnClickModal: false })
      const loading = getLoading()
      batchUpdateStateFunc(uuids, { type: 1 }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_VerificationCancelled'))
        this.fetchCostPlanList()
      })
      loading.close()
    },
    // 拒绝 按钮事件
    rejectSchemeHandler() {
      const rows = this.selectedDataList
      if (!rows || rows.length === 0) {
        this.$message.error('请勾选数据。')
        return
      }
      const index = rows.findIndex(p => p.approvedState !== 1)
      if (index !== -1) {
        this.$message.error(this.$t('Information.OnlySchemesWithAuditSubmitted'))
        return
      }
      this.rejectDialog.func = this.rejectFunc
      this.rejectDialog.visible = true
    },
    async rejectFunc(reason) {
      if (!reason) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReasonNotEntered'))
        return false
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToRejectIt'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning', closeOnClickModal: false })
      const rows = this.selectedDataList
      const uuids = []
      for (const r of rows) {
        uuids.push(r.uuid)
      }
      const loading = getLoading()
      batchUpdateStateFunc(uuids, { type: 0, reason: reason }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Denied'))
        this.fetchCostPlanList()
      })
      loading.close()
      return true
    },
    /**
     * 加载详情并跳转维护页
     * @param status 'edit': 编辑操作弹窗  ‘copy’: 复制新增弹窗
     */
    async loadDetail(status) {
      const currentRow = this.selectedRow || null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // 已审核不在编辑
      if ((currentRow.approvedState === 2 && status !== 'copy') || !this.editByRole) {
        this.chargeSchemeDialog.locked = true
      } else {
        this.chargeSchemeDialog.locked = false
      }
      this.chargeSchemeDialog.status = status
      let entity = currentRow
      await queryChargeScheme(currentRow.uuid).then(res => {
        if (res.data) {
          entity = res.data
        }
      })
      this.chargeSchemeDialog.chargeScheme = entity
      this.chargeSchemeDialog.visible = true
    },
    getValueFromChild(obj) {
      this.searchConditions[obj.key] = obj.value
    },
    // 审核状态
    approvedStateLabFun(value) {
      if (value === 0) {
        // 未审核
        return this.$t('CargoMsg.Cargo_Uncommitted')
      }
      if (value === 1) {
        // 已提交
        return this.$t('CargoMsg.Cargo_Submitted')
      }
      if (value === 2) {
        // 已审核
        return this.$t('CargoMsg.Cargo_Approved')
      }
      // 状态未知
      return this.$t('CargoMsg.Cargo_UnKnownStatus')
    },
    // 自定义高级查询条件初始化
    customSearchItemsInit() {
      // 文本框FIELD_TEXT 下拉框FIELD_DROP_DOWN_LIST 日期框FIELD_DATE_RANGE 数字框
      const defaultSearchFields = []
      // 业务类型lob
      let itemLabel = 'SeaExport.BusinessType'
      let itemName = 'lob'
      const valueExpression = { valueType: 'static', valueContent: this.lobArray }
      let searchField = this.selectAdvancedSearchField(itemLabel, itemName, valueExpression)
      defaultSearchFields.push(searchField.formatObj2Json())
      // 方案名称name
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.itemLabel = 'CargoMsg.Cargo_ProductName'
      searchField.itemName = 'name'
      searchField.fieldType = 'FIELD_TEXT'
      defaultSearchFields.push(searchField.formatObj2Json())
      // 方案说明
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.itemLabel = 'CargoMsg.Cargo_DescriptionOfPlan'
      searchField.itemName = 'remark'
      searchField.fieldType = 'FIELD_TEXT'
      defaultSearchFields.push(searchField.formatObj2Json())
      // 订舱代理bookingAgent
      if (!this.saleRoleHide) {
        itemLabel = 'SeaExport.BookingAgent'
        itemName = 'bookingAgent'
        searchField = this.selectAdvancedSearchField(itemLabel, itemName)
        searchField.itemType = 'company'
        searchField.methodParams = { bookingAgent: true }
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 委托单位customer
      itemLabel = 'SeaExport.ConsignationCompany'
      itemName = 'customer'
      searchField = this.selectAdvancedSearchField(itemLabel, itemName)
      searchField.itemType = 'company'
      searchField.methodParams = { customer: true }
      defaultSearchFields.push(searchField.formatObj2Json())
      // 承运人carrierId
      // 船公司
      itemLabel = 'CargoMsg.Cargo_Carrier_Ship'
      itemName = 'carrierIdShip'
      searchField = this.selectAdvancedSearchField(itemLabel, itemName)
      searchField.itemType = 'company'
      searchField.methodParams = { seaCmp: true, airCmp: false }
      defaultSearchFields.push(searchField.formatObj2Json())
      // 航空公司
      itemLabel = 'CargoMsg.Cargo_Carrier_Air'
      itemName = 'carrierIdAir'
      searchField = this.selectAdvancedSearchField(itemLabel, itemName)
      searchField.itemType = 'company'
      searchField.methodParams = { seaCmp: false, airCmp: true }
      defaultSearchFields.push(searchField.formatObj2Json())
      // 口岸代理
      if (!this.saleRoleHide) {
        itemLabel = 'CargoMsg.Cargo_Carrier_Railway'
        itemName = 'carrierIdRailway'
        searchField = this.selectAdvancedSearchField(itemLabel, itemName)
        searchField.itemType = 'company'
        searchField.methodParams = { portAgent: true }
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // HS CODE hsCodeTxt
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.defaultValue = ''
      searchField.itemLabel = 'HS CODE'
      searchField.itemName = 'hsCodeTxt'
      searchField.fieldType = 'FIELD_TEXT'
      searchField.dataProvider = null
      searchField.defaultSelected = 1
      defaultSearchFields.push(searchField.formatObj2Json())
      // 审核状态
      const itemLabel2 = 'CargoMsg.Cargo_AuditStatus'
      const itemName2 = 'approvedState'
      const valueExpression2 = { valueType: 'static', valueContent: this.approvedState }
      const searchField2 = this.selectAdvancedSearchField(itemLabel2, itemName2, valueExpression2)
      defaultSearchFields.push(searchField2.formatObj2Json())
      // 录入人
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'user'
      searchField.subType = {
        category: 'role',
        officeId: null
      }
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_USER'
      searchField.itemName = 'inputBy'
      searchField.itemLabel = 'CargoMsg.Cargo_CreatedBy'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())
      // 航线
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'region'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_REGION_MUTI'
      searchField.itemName = 'region'
      searchField.itemLabel = 'SeaExport.Airline'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())
      // 目的港代理
      if (!this.saleRoleHide) {
        itemLabel = 'CargoMsg.Cargo_DestinationAgent'
        itemName = 'destinationAgent'
        searchField = this.selectAdvancedSearchField(itemLabel, itemName)
        searchField.itemType = 'company'
        searchField.methodParams = { overseaAgent: true }
        searchField.defaultSelected = 0
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 起运港（海运）
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'seaport'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_SEAPORT'
      searchField.itemName = 'departureSea'
      searchField.itemLabel = 'CargoMsg.Cargo_Port_Departure_Sea'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())
      // 目的港（海运）
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'seaport'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_SEAPORT'
      searchField.itemName = 'destinationSea'
      searchField.itemLabel = 'CargoMsg.Cargo_Port_Destination_Sea'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())
      // 起运港（空运）
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'airport'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_AIRPORT'
      searchField.itemName = 'departureAir'
      searchField.itemLabel = 'CargoMsg.Cargo_Port_Departure_Air'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())
      // 目的港（空运）
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'airport'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_AIRPORT'
      searchField.itemName = 'destinationAir'
      searchField.itemLabel = 'CargoMsg.Cargo_Port_Destination_Air'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())
      // 起运港（铁路）
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'railwayStation'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_RAILWAYSTATION'
      searchField.itemName = 'departureRail'
      searchField.itemLabel = 'CargoMsg.Cargo_Port_Departure_Rail'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())
      // 目的港（铁路）
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'railwayStation'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_RAILWAYSTATION'
      searchField.itemName = 'destinationRail'
      searchField.itemLabel = 'CargoMsg.Cargo_Port_Destination_Rail'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.dataCacheKey = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())
      // 隐藏的搜索条件：承运人（口岸代理）订舱代理、目的港代理
      if (this.saleRoleHide) {
        // 订舱代理
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'company'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'bookingAgent'
        defaultSearchFields.push(searchField.formatObj2Json())
        // 口岸代理
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'company'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'carrierIdRailway'
        defaultSearchFields.push(searchField.formatObj2Json())
        // 目的港代理
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'company'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'destinationAgent'
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (defaultSearchFields.length > 0) {
        this.searchItemAutoInit = true
        return defaultSearchFields
      }
      return []
    },
    selectAdvancedSearchField(itemLabel, itemName, valueExpression, multiple) {
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = multiple || 0
      searchField.itemLabel = itemLabel || ''
      searchField.itemName = itemName || ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.valueExpression = valueExpression || ''
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
      searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_EQUAL.code
      searchField.action = 2
      return searchField
    },
    searchConditionsReset() {
      this.searchConditions = {
        lob: '',
        fba: '',
        name: '',
        bookingAgent: '',
        customer: '',
        carrier: '',
        hsCodeTxt: '',
        pageNum: 1,
        pageSize: 30,
        total: 0,
        branchId: ''
      }
    },
    setSaleRoleHideData() {
      console.log('主应用发送SaleRoleHide:', this.saleRoleHideData)
      microApp.forceSetData('child-sale-role-hide-costplan', this.saleRoleHideData)
    },
    saleRoleHideDataChange(e) {
      console.log('主应用获取SaleRoleHide:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setSaleRoleHideData()
        } else {
          this.saleRoleHide = e.detail.data.hide
          // 隐藏的设置列：订舱代理、目的港代理
          if (this.saleRoleHide && this.columnDefs && this.columnDefs.length > 0) {
            this.columnDefs = this.columnDefs.filter(item => !['bookingAgentStr', 'destinationAgentStr'].includes(item.field))
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.cost-plan {
  .el-dialog__body {
    padding: 10px 0 0 0 !important;
  }
}
</style>
